import { render, staticRenderFns } from "./AltaEntidad.vue?vue&type=template&id=6bb98d58&scoped=true&"
import script from "./AltaEntidad.vue?vue&type=script&lang=js&"
export * from "./AltaEntidad.vue?vue&type=script&lang=js&"
import style0 from "./AltaEntidad.vue?vue&type=style&index=0&id=6bb98d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb98d58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6bb98d58', component.options)
    } else {
      api.reload('6bb98d58', component.options)
    }
    module.hot.accept("./AltaEntidad.vue?vue&type=template&id=6bb98d58&scoped=true&", function () {
      api.rerender('6bb98d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/CommercialManagement/AltaEntidad.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/CommercialManagement/AltaEntidad.vue
// module id = jLfY
// module chunks = 0